import { AnimatePresence, motion } from "framer-motion";

export const LoadingShimmer = () => (
  <AnimatePresence mode="popLayout">
    <motion.div
      className="flex flex-col justify-center py-3"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
    >
      <span
        className="animate-shimmer-text pl-3 text-sm font-medium"
        style={{
          background:
            "linear-gradient(90deg, #9ca3af 0%, #d1d5db 25%, #f3f4f6 50%, #d1d5db 75%, #9ca3af 100%)",
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Loading...
      </span>
    </motion.div>
  </AnimatePresence>
);
